import { useState } from "react";
import { Get } from "../../../../Request";
import toast from "react-hot-toast";

export const useHome = () => {
  const [form, setForm] = useState({
    mobile: "",
  });
  const validation = input => {
    if (input) {
      if (input.length > 9) {
        if (input.length == 10) {
          return {
            status: true,
            mobile: "0" + input,
          };
        }
        return {
          status: true,
          mobile: input,
        };
      }
    }
    return {
      status: false,
    };
  };
  const [loading, setloading] = useState(false);
  const sendSms = async () => {
    setloading(true);
    const { status, mobile } = validation(form.mobile);
    if (status) {
      await Get({
        url: "/link/app",
        data: {
          ...{ mobile },
        },
        stat: true,
      }).then(data => {
        setForm({ mobile: "" });
        setloading(false);
        return data;
      });
    } else {
      toast.error("شماره ورودی اشتباه می باشد");
      setloading(false);
    }
  };
  return {
    form,
    setForm,
    loading,
    sendSms,
  };
};
